import { site_choices_default } from '../../chunk-SMV7EJNI.mjs';
import { logo_default } from '../../chunk-5QHANN2W.mjs';
import '../../chunk-BI277V2Z.mjs';
import '../../chunk-D6FLC3TD.mjs';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { jsx, jsxs } from 'react/jsx-runtime';

var Header = (props) => {
  const { sites, LinkComponent } = props;
  return /* @__PURE__ */ jsx(AppBar, { position: "sticky", color: "default", elevation: 0, children: /* @__PURE__ */ jsx(Toolbar, { sx: { display: "flex", gap: 2, justifyContent: "space-between" }, children: /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        minWidth: "fit-content"
      },
      children: [
        /* @__PURE__ */ jsx(logo_default, { LinkComponent }),
        /* @__PURE__ */ jsx(site_choices_default, { activeSite: "til", sites })
      ]
    }
  ) }) });
};

export { Header };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map